// src/App.jsx
// App.css は Header の CSS より先に読み込む（後勝ちで狭い画面用の指定を効かせるため）
import './App.css';

import React from 'react';
import { Route, Routes, Navigate } from 'react-router-dom';

import Protect from './Protect';
import Login from './auth/Login';
import Top from './top/Top';
import AdminEventList from './admin/eventlist';
import EventSettings from './eventsettings/eventsettings';
import EventPreview from './eventsettings/eventpreview';
import OperatorEventList from './operator/eventlist';
import EnduserEventList from './enduser/eventlist';
import EnduserEventDetail from './enduser/eventdetail';
import EnduserEventJudges from './enduser/eventjudges';
import EnduserEventRings from './enduser/eventrings';
import EnduserEventGroups from './enduser/eventgroups';
import EnduserEventGroupDetail from './enduser/eventgroupdetail';

import Header from './components/Header';


const Layout = ({ children }) => (
  <div>
    <Header />
    <div className="main-content">
      <div className="content">{children}</div>
    </div>
  </div>
);


const App = () => {
  return (
    <div className="app-container">
      <Routes>
        {/* ログイン不要（Protect で包まない） */}
        <Route path="/login" element={<Login />} />
        <Route path="/top" element={<Top />} />
        <Route path="/events/:eventId" element={<EnduserEventDetail />} />
        <Route path="/events/:eventId/judges" element={<EnduserEventJudges />} />
        <Route path="/events/:eventId/rings" element={<EnduserEventRings />} />
        <Route path="/events/:eventId/groups" element={<EnduserEventGroups />} />
        <Route path="/events/:eventId/groups/:groupNo" element={<EnduserEventGroupDetail />} />

        {/* ルート：常に公開トップへ */}
        <Route path="/" element={<Navigate to="/top" replace />} />

        {/* 管理者 */}
        <Route
          path="/admin/*"
          element={
            <Protect allowTypes={['admin', 'system']}>
              <Layout>
                <Routes>
                  <Route path="eventlist" element={<AdminEventList />} />
                  <Route path="events/:eventId/settings" element={<EventSettings basePath="/admin" />} />
                  <Route path="events/:eventId/preview" element={<EventPreview basePath="/admin" />} />
                  <Route path="*" element={<Navigate to="eventlist" replace />} />
                </Routes>
              </Layout>
            </Protect>
          }
        />

        {/* 主催者 */}
        <Route
          path="/operator/*"
          element={
            <Protect allowTypes={['operator', 'admin', 'system']}>
              <Layout>
                <Routes>
                  <Route path="eventlist" element={<OperatorEventList />} />
                  <Route path="events/:eventId/settings" element={<EventSettings basePath="/operator" />} />
                  <Route path="events/:eventId/preview" element={<EventPreview basePath="/operator" />} />
                  <Route path="*" element={<Navigate to="eventlist" replace />} />
                </Routes>
              </Layout>
            </Protect>
          }
        />

        {/* 閲覧者 */}
        <Route
          path="/enduser/*"
          element={
            <Protect allowTypes={['enduser', 'operator', 'admin', 'system']}>
              <Layout>
                <Routes>
                  <Route path="eventlist" element={<EnduserEventList />} />
                  <Route path="*" element={<Navigate to="eventlist" replace />} />
                </Routes>
              </Layout>
            </Protect>
          }
        />

        {/* fallback */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </div>
  );
};

export default App;
